import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120SchNService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters (F7004 SUCCESS PATTERN)
  saveF1120SchNForm(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=z9frws`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO,
      "jcd_key": rowData.JCD_KEY,
      "combination_key": rowData.COMBINATION_KEY,
      "trans_type_key": formData[0].editrows[0][0].trans_type_key
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(formData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'F1120_SCHD_N';
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = formData[0].editrows[0][0].trans_type_key;

    // 🚀 CRITICAL: Build checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID,
      "cdr_number": rowData.CDR_NO || rowData.TAX_CODE,
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY),
      "reporting_period": String(rowData.REPORTING_PERIOD),
      "combination_key": String(rowData.COMBINATION_KEY),
      "scenario_key": parseInt(filterParams.scenario || 74)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add other required fields from rowData
    if (rowData.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }
    params.scenarioCode = 'RAF';
    params.is_issue_key_enabled = 'N';

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}